export default "__VITE_ASSET__4bW3IxA9__"